import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { ApiTypes, UITypes } from "types"

interface CellProps {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

export const statusLabels: Record<ApiTypes.Model.ReferralStatus, string> = {
  pending_approval: "In review",
  submitted: "Submitted",
  in_progress: "In progress",
  installed: "Installed",
  denied: "Denied",
}

export const StatusBadge = styled.span<{ $status: ApiTypes.Model.ReferralStatus }>`
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid transparent;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  ${({ $status }) => {
    switch ($status) {
      case "installed":
        return `
          color: var(--status-success-text);
          border-color: var(--status-success);
          background: var(--status-success-subtle);
        `
      case "in_progress":
        return `
          color: var(--status-info-text);
          border-color: var(--status-info);
          background: var(--status-info-subtle);
        `
      case "pending_approval":
        return `
          color: var(--status-warning-text);
          border-color: var(--status-warning);
          background: var(--status-warning-subtle);
        `
      case "submitted":
        return `
          color: var(--status-info-text);
          border-color: var(--status-info);
          background: var(--status-info-subtle);
        `
      case "denied":
        return `
          color: var(--status-danger-text);
          border-color: var(--status-danger);
          background: var(--status-danger-subtle);
        `
      default:
        return `
          color: var(--text-secondary);
          border-color: var(--border-strong);
          background: var(--surface-2);
        `
    }
  }}
`

const StatusSummary = styled.span`
  font-size: 13px;
  color: var(--text-primary);
  white-space: nowrap;
`

export const ReferralStatusCell = ({ cell: { row, getValue } }: CellProps) => {
  const value = getValue().value ? String(getValue().value) : ""

  if (!value) return null

  if (row.original.subRows?.length) {
    return <StatusSummary>{value}</StatusSummary>
  }

  const status = value as ApiTypes.Model.ReferralStatus
  return <StatusBadge $status={status}>{statusLabels[status] ?? value}</StatusBadge>
}
